/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.carte.ts
 *
 * Messages de la carte publique en plein écran (`/carte`) : recherche avec
 * suggestions, fiche du stand (bas d'écran sur téléphone, panneau latéral sur
 * grand écran), liste des stands, boutons flottants, partage d'un lien vers
 * un stand. Les anciens messages `plan.*` restent au noyau (fr.ts).
 * Le mot qui désigne les structures présentes vient du lexique de
 * l'événement ({lexExhibitor...}), celui des activités aussi.
 * Fusionné dans fr.ts. Demande de Mika du 2026-10-08.
 *
 * Mikael - chef de projet - 2026-10-08
 */
export const messagesCarteFr: Record<string, string> = {
  // Recherche
  'carte.recherche.placeholder': 'Chercher un stand',
  'carte.recherche.aria': 'Rechercher un stand par nom ou par numéro',
  'carte.recherche.suggestions': 'Suggestions',
  'carte.recherche.aucune': 'Aucun stand ne correspond à « {saisie} ».',
  'carte.recherche.effacer': 'Effacer la recherche',
  'carte.recherche.stand': 'Stand {code}',

  // Boutons flottants et barre
  'carte.btn.toutVoir': 'Voir tout le plan',
  'carte.btn.pleinEcran': 'Plein écran',
  'carte.btn.quitterPleinEcran': 'Quitter le plein écran',
  'carte.btn.liste': 'Liste des {lexExhibitorPlural}',
  'carte.btn.fermerListe': 'Fermer la liste',
  'carte.favoris.chip': 'Mes favoris ({n})',
  'carte.favoris.aria': 'Afficher seulement mes favoris ({n})',

  // Carte
  'carte.region.aria': 'Plan interactif. Flèches pour déplacer, plus et moins pour zoomer, zéro pour tout voir.',
  'carte.zone.ariaStand': 'Stand {code}, {nom}',
  'carte.zone.ariaStandFavori': 'Stand {code}, {nom}, dans mes favoris',
  'carte.astuce': 'Touchez un stand pour voir sa fiche.',
  'carte.astuce.fermer': 'Masquer l’astuce',
  'carte.fond.chargement': 'Chargement du plan…',
  'carte.fond.erreur': 'Le fond du plan n’a pas pu être chargé : les stands restent utilisables.',
  'carte.introuvable': 'Le stand {code} n’est pas sur le plan.',

  // Fiche du stand
  'carte.fiche.aria': 'Fiche du stand {code}',
  'carte.fiche.numero': 'Stand {code}',
  'carte.fiche.fermer': 'Fermer la fiche',
  'carte.fiche.retourListe': 'Retour à la liste',
  'carte.fiche.voirFiche': 'Voir la fiche {lexExhibitorOfDef}',
  'carte.fiche.offres': '{n, plural, one {1 offre d’emploi} other {# offres d’emploi}}',
  'carte.fiche.secteur': 'Secteur : {secteur}',
  'carte.fiche.partager': 'Partager',
  'carte.fiche.partageTitre': 'Stand {code}, {nom}',
  'carte.fiche.lienCopie': 'Lien du stand copié.',
  'carte.fiche.lienACopier': 'Lien du stand : {url}',
  'carte.fiche.favoriAjoute': 'Ajouté à vos favoris.',
  'carte.fiche.favoriRetire': 'Retiré de vos favoris.',

  // Liste
  'carte.liste.titre': 'Liste des {lexExhibitorPlural}',
  'carte.liste.compte': '{n, plural, one {1 stand} other {# stands}}',
  'carte.liste.filtre': 'Filtrer la liste',
  'carte.liste.filtrePlaceholder': 'Filtrer par nom ou numéro',
  'carte.liste.vide': 'Aucun stand ne correspond.',
  'carte.liste.videFavoris': 'Aucun favori pour l’instant : touchez l’étoile de la fiche d’un stand.',
  'carte.liste.offres': '{n, plural, one {1 offre} other {# offres}}',

  // Légende
  'carte.legende.reperes': 'Repères',
  'carte.legende.selection': 'Stand choisi',
  'carte.legende.resultat': 'Résultat de recherche',
  'carte.legende.favori': 'Mes favoris',
};
